import RewardsV2List from './RewardsV2List';

export default RewardsV2List;
